var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "video-view",
        { attrs: { "video-id": "https://vimeo.com/625577468/47d3ed3bf5" } },
        [
          _c("template", { slot: "title-first" }, [
            _c("div", [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("header_4_1")) + "\n        "
              ),
              _c("div", { staticClass: "underline" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("header_4_2")) + "\n        "
                )
              ])
            ])
          ]),
          _c(
            "video",
            {
              attrs: { autoplay: "", muted: "", loop: "", playsinline: "" },
              domProps: { muted: true }
            },
            [
              _c("source", {
                attrs: {
                  type: "video/mp4",
                  src:
                    "https://media.blissapplications.com/videos/desktop-1440-clip-home.mp4"
                }
              })
            ]
          )
        ],
        2
      ),
      _c("info-view"),
      _c("services-view"),
      _c("handoff-view"),
      _c("footer-contact-view"),
      _c("footer-location-view"),
      _c("footer-awards-view"),
      _c("footer-portugal-2020-view"),
      _c("footer-follow-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56b687e3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b687e3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
// module id = 477
// module chunks = 12